export const PATH_META_MANAGER = '/meta-manager';
export const PATH_CODELISTS = PATH_META_MANAGER + '/codelists';
export const PATH_CONCEPT_SCHEMES = PATH_META_MANAGER + '/concept-schemes';
export const PATH_CATEGORY_SCHEMES = PATH_META_MANAGER + '/category-schemes';
export const PATH_DATA_STRUCTURE_DEFINITIONS = PATH_META_MANAGER + '/data-structure-definitions';
export const PATH_DATAFLOWS = PATH_META_MANAGER + '/dataflows';
export const PATH_CATEGORISATIONS = PATH_META_MANAGER + '/categorisations';
export const PATH_HIERARCHICAL_CODELISTS = PATH_META_MANAGER + '/hierarchical-codelists';
export const PATH_AGENCY_SCHEMES = PATH_META_MANAGER + '/agency-schemes';
export const PATH_DATA_PROVIDER_SCHEMES = PATH_META_MANAGER + '/data-provider-schemes';
export const PATH_DATA_CONSUMER_SCHEMES = PATH_META_MANAGER + '/data-consumer-schemes';
export const PATH_ORGANIZATION_UNIT_SCHEMES = PATH_META_MANAGER + '/organization-unit-schemes';
export const PATH_CONTENT_CONSTRAINTS = PATH_META_MANAGER + '/content-constraints';
export const PATH_STRUCTURE_SETS = PATH_META_MANAGER + '/structure-sets';
export const PATH_PROVISION_AGREEMENTS = PATH_META_MANAGER + '/provision-agreements';
export const PATH_REGISTRATIONS = PATH_META_MANAGER + '/registrations';
export const PATH_CATEGORY_SCHEMES_AND_DATAFLOWS = PATH_META_MANAGER + '/category-schemes-and-dataflows';
export const PATH_MSD = PATH_META_MANAGER + '/msds';
export const PATH_METADATAFLOWS = PATH_META_MANAGER + '/metadataflows';

export const PATH_DATA_MANAGER = '/data-manager';
export const PATH_BUILDER = PATH_DATA_MANAGER + '/builder';
export const PATH_FILE_MAPPING = PATH_DATA_MANAGER + '/file-mapping';
export const PATH_LOADER = PATH_DATA_MANAGER + '/loader';
export const PATH_DATAFLOW_BUILDER = PATH_DATA_MANAGER + '/dataflow-builder';
export const PATH_CUBE_LIST = PATH_DATA_MANAGER + '/cube-list';
export const PATH_MANAGE_SERIES = PATH_DATA_MANAGER + '/manage-series';
export const PATH_UPGRADE_DSD = PATH_DATA_MANAGER + '/upgrade-dsd';
export const PATH_SYNCRONIZE_CODELISTS = PATH_DATA_MANAGER + '/synchronize-codelists';
export const PATH_ATTRIBUTE = PATH_DATA_MANAGER + '/attribute-file';
export const PATH_DDB_RESET = PATH_DATA_MANAGER + '/ddb-reset';
export const PATH_REMOVE_TEMP_TABLES = PATH_DATA_MANAGER + '/remove-temp-tables';
export const PATH_UPDATE_DATABROWSER_CACHE = PATH_DATA_MANAGER + '/update-databrowser-cache';

export const PATH_EASY_LOADING = '/easy-loading';
export const PATH_EASY_LOADING_CREATE = PATH_EASY_LOADING + '/easy-loading-create';
export const PATH_EASY_LOADING_UPDATE = PATH_EASY_LOADING + '/easy-loading-update';

export const PATH_UTILITIES = '/utilities';
export const PATH_IMPORT_STRUCTURES = PATH_UTILITIES + '/import-structures';
export const PATH_COMPARE_DSDS = PATH_UTILITIES + '/compare-dsds';
export const PATH_COMPARE_ITEM_SCHEMES = PATH_UTILITIES + '/compare-item-schemes';
export const PATH_MERGE_ITEM_SCHEMES = PATH_UTILITIES + '/merge-item-schemes';
export const PATH_ARTEFACT_BROWSER = PATH_UTILITIES + '/artefact-browser';

export const PATH_REFERENCE_METADATA = '/reference-metadata';
export const PATH_METADATA_SET = PATH_REFERENCE_METADATA + '/metadata-set';
export const PATH_DCAT_AP_IT = PATH_REFERENCE_METADATA + '/dcat-ap-it';

export const PATH_MANAGE_USERS = '/users';
export const PATH_USER_MANAGEMENT = PATH_MANAGE_USERS + '/user-management';
export const PATH_SET_PERMISSIONS = PATH_MANAGE_USERS + '/permissions';

export const PATH_CONFIGURATION = '/configurations';
export const PATH_APP_CONFIGURATION = PATH_CONFIGURATION + '/app';
export const PATH_NODES_CONFIGURATION = PATH_CONFIGURATION + '/nodes';



// WEBPACK FOOTER //
// ./src/constants/paths.js